<app-section-layout [itemTemplate]="sbuGraph" [dataForChart]="graphData" ></app-section-layout>

<ng-template #sbuGraph let-data="data" let-sectionNavState="sectionNavState">
    <app-sbu-slide [sbuGraph]="data.graph" [navState]="sectionNavState"></app-sbu-slide>
</ng-template>